.items {
  top: -1000px;
  z-index: 15;
  position: absolute;
  box-shadow:
    0 12px 28px 0 rgb(0 0 0 / 20%),
    0 2px 4px 0 rgb(0 0 0 / 10%),
    inset 0 0 0 1px rgb(255 255 255 / 50%);
  min-width: 100px;
  min-height: 40px;
  background-color: white;
}
